export const optionCardStyleProps = {
	boxShadow: 'md',
	borderWidth: '1px',
	borderRadius: 'md',
	color: 'gray.800',
	fontWeight: 'bold',
	p: '1rem',
};
